import { render, staticRenderFns } from "./datetime.vue?vue&type=template&id=23b7386a&scoped=true"
import script from "./datetime.vue?vue&type=script&lang=ts"
export * from "./datetime.vue?vue&type=script&lang=ts"
import style0 from "./datetime.vue?vue&type=style&index=0&id=23b7386a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b7386a",
  null
  
)

export default component.exports